import React, { useState, useEffect } from 'react';
import './ManualInputData.scss';
import { getManualSkuList } from '../../helper/helper';
import Tooltip from '@mui/material/Tooltip';
import AccessorySkuModal from './AccessorySkuModal';
import IconButton from '@mui/material/IconButton';
//import FileUploadIcon from '@mui/icons-material/FileUpload';

import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Loader from '../../components/Loader/Loader';

const ManualInputData = () => {
  const [skuApi, setSkuApi] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [modalIsOpen, setModalIsOpen] = useState(false);

  async function getRawUserData() {
    setIsLoading(true);
    try {
      let { data } = await getManualSkuList();
      let objToCheck = data[0]?.manualFile?.[0];
      // Remove this check after Live version is alligned with updated structure
      if (!objToCheck?.sku) {
        setIsLoading(false);
        return
      } else {
        setSkuApi(data[0].manualFile);
      }
      if (data[0].manualFile.length > 0) {
        setIsLoading(false);
      }
    } catch (error) {
      return error;
    }
  }

  useEffect(() => {
    getRawUserData();
  }, []);

  const headers = [
    { key: 'created_at', label: 'Date Created' },
    { key: 'sku', label: 'SKU' },
    { key: 'name', label: 'Accessory Name' },
    { key: 'cost', label: 'Cost' },
    { key: 'msrp', label: 'MSRP' },
  ];

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredData = skuApi.filter(
    (item) =>
      item?.sku?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item?.name?.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const clearSearch = () => {
    setSearchTerm('');
  };

  const openModal = () => {
    setModalIsOpen(true);
  };
  const closeModal = () => {
    setModalIsOpen(false);
  };

  return (
    <div className="manual">
      <div className="manual-container">
        <div className="manual-block">
          <div className="manual-block-container">
            <div className="bot">
               <div className="note">
                 
                  <p>  <strong>Note:</strong> &nbsp;Choose a .xlsx file that includes 5 columns: <strong> SKU, Accessory Name, Cost, MSRP, and Date Created.</strong>
                 </p>
                </div>
              <div className="top-bar">
                <div className="upload-button-container">
                  
                  <p>Upload Accessory SKU Sheet</p>
                  <AccessorySkuModal modalIsOpen={modalIsOpen} closeModal={closeModal} refetch={getRawUserData} />
                  <Tooltip title="Upload File" arrow placement="top">
                    <IconButton sx={{ ml: 2 }} onClick={openModal}>
                      <CloudUploadIcon />
                    </IconButton>
                  </Tooltip>
                </div>
                <div className="search">
                  <input
                    type="text"
                    placeholder="Search by SKU or Accessory Name"
                    value={searchTerm}
                    name="search"
                    onChange={handleSearch}
                    className="search-input"
                  />
                  {searchTerm && (
                    <button onClick={clearSearch} className="clear-button">
                      &times;
                    </button>
                  )}
                </div>
              </div>
 
              {isLoading ? (
                <Loader />
              ) : (
                <>
                  <div className="table">
                    <table className="professional-table">
                      <thead>
                        <tr>
                          {headers.map((header) => (
                            <Tooltip
                              key={header.key}
                              title={`${header.label}`}
                              arrow
                              placement="top"
                            >
                              <th>{header.label}</th>
                            </Tooltip>
                          ))}
                        </tr>
                      </thead>
                      {filteredData?.length === 0 ? (
                        <tbody>
                          <tr>
                            <td colSpan={5} style={{ textAlign: 'center' }}>
                              No data found. Please upload SKU file.
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        filteredData.map((sku, index) => (
                          <tbody key={index}>
                            <tr key={index}>
                              <td>{sku?.created_at}</td>
                              <td>{sku?.sku}</td>
                              <td>{sku?.name}</td>
                              <td>{sku?.cost}</td>
                              <td>{sku?.msrp}</td>
                             
                            </tr>
                          </tbody>
                        ))
                      )}
                    </table>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManualInputData;
